<template>
  <header class="hello">
    <img
      id="logo"
      alt="Void Shelter Logo"
      src="../assets/images/VoidShelter_logo.png"
    />

    <iframe
      width="800"
      height="450"
      src="https://www.youtube.com/embed/arhg3uP_Kf0"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>

    <div class="socialNetwork">
      <a target="_blank" href="https://www.facebook.com/VoidShelter/"
        ><img
          id="facebook"
          alt="Icone Facebook"
          src="../assets/icones/facebook.png"
      /></a>
      <a target="_blank" href="https://www.instagram.com/voidshelter/"
        ><img
          id="instagram"
          alt="Icone Instagram"
          src="../assets/icones/instagram.png"
      /></a>
      <a
        target="_blank"
        href="https://www.youtube.com/channel/UCWn99BkyA2kDDdoyoZs94EQ"
        ><img
          id="youtube"
          alt="Icone Youtube"
          src="../assets/icones/youtube.png"
      /></a>
      <a
        target="_blank"
        href="https://music.apple.com/fr/artist/void-shelter/1444482400"
        ><img id="apple" alt="Icone Apple" src="../assets/icones/applemusic.png"
      /></a>
      <a
        target="_blank"
        href="https://open.spotify.com/artist/07mCmCrnXwSwa79dxPtQjT"
        ><img
          id="spotify"
          alt="Icone Spotify"
          src="../assets/icones/spotify.png"
      /></a>
      <a target="_blank" href="https://www.deezer.com/fr/artist/54632852"
        ><img id="deezer" alt="Icone Deezer" src="../assets/icones/deezer.png"
      /></a>
      <a target="_blank" href="https://voidshelter.bandcamp.com/"
        ><img
          id="bandcamp"
          alt="Icone Bandcamp"
          src="../assets/icones/bandcamp.png"
      /></a>
      <a target="_blank" href="https://soundcloud.com/voidshelter"
        ><img
          id="soundcloud"
          alt="Icone SoundCloud"
          src="../assets/icones/soundcloud.png"
      /></a>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
header {
  width: 100vw;
  height: 100vh;
  background: url("../assets/images/header_site.jpg") no-repeat center center
    fixed;
  background-size: cover;
  color: #fff;
  text-align: left;
  position: relative;
}
#logo {
  width: 380px;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  display: block;
}

iframe {
  display: block;
  margin: 40px auto;
  max-width: 96%;
}

@media screen and (max-width: 960px) {
  iframe {
    width: 560px;
    height: 315px;
  }
}

.socialNetwork {
  position: absolute;
  bottom: 50px;
  right: 30px;
  display: flex;
  justify-content: flex-end;
}
.socialNetwork a {
  border: none;
}

.socialNetwork > a > img {
  object-fit: contain;
  width: 20px;
  height: 20px;
  margin: 0px 8px;
}

#bandcamp,
#youtube,
#soundcloud {
  width: 25px;
}
</style>
